import React from 'react';
import Input from '../../Input';
export default function Price(props) {
    return <Input {...props}></Input>;
}
